import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { API } from "@/lib/auth";
import axios from "axios";
import { MicrositeView } from "@/pages/WebsiteBuilder";
import { Icon } from "@/components/kit";

export default function Microsite() {
  const { slug } = useParams();
  const [site, setSite] = useState(undefined);
  useEffect(() => { axios.get(`${API}/site/${slug}`).then((r) => setSite(r.data)).catch(() => setSite(null)); }, [slug]);

  if (site === undefined) return <div className="h-screen grid place-items-center text-gray-400 font-head">Loading…</div>;
  if (site === null) return (
    <div className="h-screen grid place-items-center text-center px-6">
      <div><Icon name="Globe" size={40} className="mx-auto text-gray-300 mb-3" /><h1 className="font-head text-2xl font-bold">Site not found</h1>
        <p className="text-gray-500 mt-1">This MFD hasn't published a microsite yet.</p>
        <Link to="/" className="text-blue-600 font-semibold mt-4 inline-block">← Back to MFDX</Link></div>
    </div>
  );
  return (
    <div className="min-h-screen bg-white">
      <MicrositeView site={site} />
    </div>
  );
}
